import SuccessfulPaymentPage from "pages/SuccessfulPaymentPage";

const Success = SuccessfulPaymentPage;
export { Success };